<template>
    <div class="autocomplete">
        <input
                v-model="search"
                @input="onChange"
                @keydown.down="onArrowDown"
                @keydown.up="onArrowUp"
                @keydown.enter="onEnter"
                type="text"
                class="form-control"
        />
        <ul
                v-show="isOpen"
                class="autocomplete-results"
        >
            <li
                    v-if="isLoading"
                    class="loading"
            >
                Recherche en cours...
            </li>
            <li
                    v-else
                    v-for="(result, i) in results"
                    :key="i"
                    @click="setResult(result)"
                    class="autocomplete-result"
                    :class="{ 'is-active': i === arrowCounter }"
            >
                {{ result.nom }} {{ result.cp }}
            </li>
        </ul>
    </div>
</template>

<script>
    export default {
        name: 'SearchAutocomplete',
        props: ['token', 'site', 'user', 'racine', 'userId','systemeClient','search'],
        data() {
            return {
                items: {
                    type: Array,
                    required: false,
                    default: () => [],
                },
                isAsync: {
                    type: Boolean,
                    required: false,
                    default: false,
                },
                //search: '',
                villeId: null,
                results: [],
                isOpen: false,
                arrowCounter: -1
            };
        },
        mounted() {
            document.addEventListener('click', this.handleClickOutside);
        },
        destroyed() {
            document.removeEventListener('click', this.handleClickOutside);
        },
        watch: {
            items: function (value, oldValue) {
                if (this.isAsync) {
                    this.results = value;
                    this.isOpen = true;
                    this.isLoading = false;
                    console.log(oldValue)
                }
            }
        },
        methods: {
            filterResults() {
                this.results = this.items.filter(item => item.toLowerCase().indexOf(this.search.toLowerCase()) > -1);
            },
            onChange() {

                //this.isLoading = true
                if(this.search.length>1) {
                    fetch(this.racine + this.site + 'api/get_auto_completion_ville_france/' + this.search, {
                        method: 'GET',
                        headers: {
                            'Content-Type': 'application/json',
                            'Authorization': 'Bearer ' + this.token
                        },
                    }).then(response => {
                        console.log(response)
                        response.json().then(json => {
                            if (json != undefined) {
                                console.log(json)
                                this.items = json['listVille']
                                this.filterResults()

                            }
                            this.isOpen = true
                            //this.isLoading = false
                        })
                    })

                }
            },
            setResult(result) {
                this.search = result.nom+ ' '+result.cp;
                this.villeId = result.id;
                this.isOpen = false;

                this.$emit('input', this.villeId);
                this.$emit('inputNom', this.search);
            },
            handleClickOutside(event) {
                if (!this.$el.contains(event.target)) {
                    this.arrowCounter = -1;
                    this.isOpen = false;
                }
            },
            onArrowDown() {
                if (this.arrowCounter < this.results.length) {
                    this.arrowCounter = this.arrowCounter + 1;
                }
            },
            onArrowUp() {
                if (this.arrowCounter > 0) {
                    this.arrowCounter = this.arrowCounter - 1;
                }
            },
            onEnter() {
                this.search = this.results[this.arrowCounter];
                this.arrowCounter = -1;
                this.isOpen = false;
            }
        },
    }
</script>

<style>
    .autocomplete {
        position: relative;
    }

    .autocomplete-results {
        padding: 0;
        margin: 0;
        border: 1px solid #eeeeee;
        height: 120px;
        min-height: 1em;
        max-height: 6em;
        overflow: auto;
    }

    .autocomplete-result {
        list-style: none;
        text-align: left;
        padding: 4px 2px;
        cursor: pointer;
    }

    .autocomplete-result.is-active,
    .autocomplete-result:hover {
        background-color: #4AAE9B;
        color: white;
    }
</style>